var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    attrs: {
      items: _vm.times,
      label: _vm.label,
      outlined: _vm.outlined,
      dense: _vm.dense
    },
    on: { change: _vm.changed },
    model: {
      value: _vm.time,
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }